module.exports = __webpack_public_path__ + "img/nodata.8586254c.png";